var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-author"},[_c('anim-text',{staticClass:"t-t-3",attrs:{"text":_vm.copy,"tag":"h3","visible":_vm.isVisible,"reveal.once":"true","chars":false,"word":false,"lines":true,"is-axis-y":false,"duration-in":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }